import { Component, HostListener, OnInit } from '@angular/core';
import { SegovSigepoPortalBodyComponent } from '../../controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { Router } from '@angular/router';
import { SegovPage } from 'src/app/app.routes';
import { CardComunicadosComponent } from './sub-views/card-comunicados/card-comunicados.component';
import { ControlsModule } from "segov-sigepo-lib";
import { EdicaoDoDiaComponent } from './sub-views/edicao-do-dia/edicao-do-dia.component';
import { TitulosServicos } from 'src/app/utils/common.collections';
import { EServico } from 'src/app/domain/enums/servico.enum';
import { CardCarousel, ItemCarousel } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/controls/segov-sigepo-card-carousel/segov-sigepo-card-carousel.component';
import { CardWithImage } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/controls/segov-sigepo-card-with-image/segov-sigepo-card-with-image.component';
import { ScreenUtils } from 'src/app/utils/screen.utils';
import { environment } from 'src/app/environments/environment';

@Component({
  selector: 'app-inicio-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    CardComunicadosComponent,
    EdicaoDoDiaComponent,
    ControlsModule
  ],
  templateUrl: './inicio-page.component.html',
  styleUrl: './inicio-page.component.css'
})
export class InicioPageComponent implements OnInit {

  public exibirNotificacao = false; //Placeholder
  public Cards: ItemCarousel[] =  [];
  public numeroItensPorPagina = 2;
  private subItems: CardCarousel[] =
  [
    { src: '/icons/icone-publicacao.svg', descricao: TitulosServicos[EServico.publicacaoMateria].servico, rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.publicacaoMateria].servico},
    { src: '/icons/icone-consulta.svg', descricao: TitulosServicos[EServico.consulta].servico, rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.consulta].servico },
    { src: '/icons/icone-ressarcimento.svg', descricao: TitulosServicos[EServico.ressarcimentoValores].servico, rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.ressarcimentoValores].servico },
    { src: '/icons/icone-gratuidade.svg', descricao: TitulosServicos[EServico.gratuidadePublicacao].servico , rota: SegovPage.Servicos,  rotaParametros: TitulosServicos[EServico.gratuidadePublicacao].servico },
  ]

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.Cards = this.mapCardsCarouselBasedOnScreenSize();
  }

  ngOnInit(): void {
    this.Cards = this.mapCardsCarouselBasedOnScreenSize();

    const primeiroCarregamento = localStorage.getItem("primeiroCarregamento");
    localStorage.setItem("primeiroCarregamento", "1");
    if(!primeiroCarregamento)
      this.exibirNotificacao = environment.showNotificationModal;
  }

  public mapCardsCarouselBasedOnScreenSize() : ItemCarousel[] {
    if(ScreenUtils.getScreenResolution() >= 992)
      this.numeroItensPorPagina = 2;
    else
      this.numeroItensPorPagina = 1;

    const groupCards: ItemCarousel[] = [{subItems: []}]
    const numSubitems = this.subItems.length;
    let countNewGroup = 0;
    for(let i = 0; i < numSubitems; i++){
      groupCards[countNewGroup].subItems.push(this.subItems[i]);
      if((i+1) % this.numeroItensPorPagina === 0 && i+1 !== numSubitems){
        groupCards.push({subItems: []});
        countNewGroup++;
      }
    }
    return groupCards;
  }

  public InformacoesOficiais: CardWithImage[] = [
    {src: "background/historia-jornal.png", titulo: "História do Jornal", descricao: "Conheça a trajetória de mais de 130 anos do jornal e sua relevância nos tempos atuais", rota: SegovPage.HistoriaJornal, textoBotao: "Ver mais", imagemTodoBg: true  },
    {src: "background/morte-santos-dumont-bg.png", titulo: "Reportagens Históricas", descricao: "Acesse destaques e fatos históricos noticiados pelo jornal ao longo dos anos", rota: SegovPage.ReportagensIconicas, textoBotao: "Ver mais", imagemTodoBg: true},
    {src: "background/sumario-bg.png", titulo: "Glossário", descricao: "Conheça algumas palavras e expressões utilizadas no dia a dia das publicações", rota: SegovPage.Glossario, textoBotao: "Ver mais", imagemTodoBg: true},
  ]

  public DiarioFeitoParaVoce: CardWithImage[] = [
    {src: "background/digitalizacao.png", titulo: "Digitalização do Diário Oficial", descricao: "Confira informações e novidades do projeto que busca disponibilizar todo o acervo do jornal na palma da mão", rota: SegovPage.HistoriaJornal, rotaParametros: "Digitalização do acervo", textoBotao: "Ver mais", imagemTodoBg: false},
    {src: "background/autenticidade.png", titulo: "Autenticidade da publicação", descricao: "Consulte aqui a veracidade das publicações de seu interesse", rota: SegovPage.Autenticidade, textoBotao: "Ver mais", imagemTodoBg: false},
    {src: "background/agencia-minas.png", titulo: "Noticiário", descricao: "Acesse aqui o noticiário de Minas", rotaExterna: "https://www.agenciaminas.mg.gov.br", textoBotao: "Ver mais", imagemTodoBg: false},
  ]

  constructor(private router: Router){}

  public goToComunicados(){
    this.router.navigate([SegovPage.Comunicados]);
  }


}